import React, { forwardRef, ReactNode } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import parse from "html-react-parser"
import { Header } from "../header"
import { Footer } from "../footer"
import { GlobalStyle } from "@interia/common"
import { Layout as GlobalLayout } from "@interia/common/components/layout"
import useParentMenu from "../../hooks/useParentMenu"
import useFooter from "../../hooks/useFooter"
import useHeader from "../../hooks/useHeader"

type Props = {
  isHomePage?: boolean
  children: ReactNode
  actualSite: string
}

const Layout = forwardRef(
  ({ isHomePage = false, children, actualSite }: Props, ref) => {
    const menuItems = useParentMenu()
    const header = useHeader()
    const {
      wp: {
        generalSettings: { title },
      },
    } = useStaticQuery(graphql`
      query LayoutQuery {
        wp {
          generalSettings {
            title
            description
          }
        }
      }
    `)

    const footer = useFooter()

    return (
      <div className="global-wrapper" data-is-root-path={isHomePage}>
        <GlobalLayout
          gemiusId="zDgwCz.4k_V82Ot3_17DwpPc7A_uLiybBNhGFY0BPo..C7"
          footer={footer}
          logoUrl={{
            external: false,
            url: "/",
            image: header?.headeroptions.logo,
          }}
          menuItems={menuItems}
          actualSite="kariera"
          ref={ref}
          headerChildren={<Header actualSite={actualSite} />}
        >
          {children}
        </GlobalLayout>
      </div>
    )
  }
)

export default Layout
